import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bharatbenzbusonrentpune() {


const cardData = {
keyword: "Bharat Benz bus on Rent Pune",
headingDescription: "Ruturaj Enterprises offers Bharat Benz bus on rent in Pune for comfortable and organized group transportation across local and outstation routes. These buses are suitable for families, tourists, corporate teams, school groups, wedding parties, event organizers and large travel groups looking for dependable transportation with comfortable seating and spacious interiors. From local sightseeing and airport transfers to multi-day tours, weddings, picnics and corporate events, Bharat Benz bus rental can be planned according to passenger capacity, route and travel duration.",
topPlaces: [
{
title: "Lonavala",
description: "Lonavala is a popular hill destination for family holidays, corporate outings, school trips and weekend group tours from Pune. A Bharat Benz bus provides a convenient way for larger groups to travel together while carrying luggage and enjoying a comfortable road journey."
},
{
title: "Mahabaleshwar",
description: "Mahabaleshwar offers scenic viewpoints, valleys, strawberry farms and several attractions suitable for group sightseeing. Hiring a Bharat Benz bus from Pune is useful for families, tourist groups and organizations planning a full-day or multi-day trip."
},
{
title: "Goa",
description: "Goa is a popular long-distance destination for family vacations, college groups, corporate outings and celebrations. A spacious Bharat Benz bus can make the extended road journey more convenient for groups traveling together with luggage."
},
{
title: "Aurangabad",
description: "Aurangabad is known for heritage attractions and is suitable for educational tours, family trips and organized sightseeing programs. A Bharat Benz rental bus from Pune allows larger groups to travel together while following a planned itinerary."
},
{
title: "Alibaug",
description: "Alibaug attracts families, friends, corporate teams and wedding groups looking for a coastal getaway near Pune. A comfortable Bharat Benz bus can accommodate a larger group and provide convenient transportation for beach visits and local sightseeing."
},
{
title: "Nashik",
description: "Nashik offers religious attractions, vineyards, temples and scenic destinations for different types of group tours. Bharat Benz bus rental from Pune is suitable for pilgrimage groups, family trips, corporate outings and tourist itineraries."
},
{
title: "Kolhapur",
description: "Kolhapur is a popular destination for pilgrimage, heritage and cultural travel, particularly for groups visiting temples and historic attractions. A Bharat Benz bus offers a convenient group transportation solution for the longer journey from Pune."
},
{
title: "Matheran",
description: "Matheran is a scenic hill destination known for viewpoints, walking trails and a peaceful environment. Groups can travel by Bharat Benz bus from Pune to the nearby access area and coordinate their onward sightseeing arrangements conveniently."
},
{
title: "Shirdi",
description: "Shirdi is an important pilgrimage destination visited by families, devotees and organized tour groups. Bharat Benz bus rental provides a practical way for larger groups to travel together from Pune with space for luggage and personal belongings."
},
{
title: "Ganpatipule",
description: "Ganpatipule is a popular Konkan destination combining beaches, scenic surroundings and religious attractions. A Bharat Benz bus is useful for families, tourist groups and organizations planning a longer group tour from Pune."
}
],
services: [
{
name: "BharatBenz Bus Rental Pune",
description: "BharatBenz bus rental in Pune provides a comfortable group transportation option for local trips, outstation tours, events and special occasions. Ruturaj Enterprises can arrange suitable BharatBenz buses for families, companies, schools, tourists and large travel groups."
},
{
name: "Bharat Benz Bus Hire Pune",
description: "Bharat Benz bus hire in Pune is suitable when a group needs a dedicated vehicle for convenient shared travel. It can be used for sightseeing, weddings, corporate programs, school excursions, family holidays, picnics and longer road journeys."
},
{
name: "Bharat Benz Bus Booking Pune",
description: "Bharat Benz bus booking in Pune can be planned according to the number of passengers, destination and duration of the trip. Advance booking is particularly useful for weddings, school tours, corporate events, holiday groups and busy travel periods."
},
{
name: "Bharat Benz AC Bus on Rent Pune",
description: "Bharat Benz AC buses on rent in Pune are a suitable choice for groups that prioritize passenger comfort during local and long-distance travel. Air-conditioned travel can make extended journeys more pleasant for families, tourists, corporate teams and event groups."
},
{
name: "Bharat Benz Luxury Bus Rental Pune",
description: "Luxury Bharat Benz bus rental in Pune is suitable for premium group travel, weddings, corporate events, destination celebrations and special tours. Comfortable interiors and a spacious travel environment help make longer group journeys more convenient."
},
{
name: "Bharat Benz Tourist Bus Pune",
description: "Bharat Benz tourist buses in Pune are suitable for sightseeing tours, holiday groups, pilgrimage programs and multi-destination travel. Groups can remain together in one dedicated vehicle while following a planned route and sightseeing schedule."
},
{
name: "Bharat Benz Bus for Outstation Pune",
description: "A Bharat Benz bus for outstation travel from Pune is useful for groups traveling to hill stations, beaches, pilgrimage destinations, heritage cities and other states. Spacious seating and group-oriented transportation make it practical for one-day and multi-day journeys."
},
{
name: "Bharat Benz Bus for Wedding Pune",
description: "Bharat Benz buses can be hired for wedding transportation in Pune to move guests between homes, hotels, venues and reception locations. A dedicated bus helps families coordinate larger groups efficiently during wedding functions and celebrations."
},
{
name: "Bharat Benz Bus for Corporate Events Pune",
description: "Corporate teams can use Bharat Benz buses for conferences, seminars, exhibitions, employee outings, meetings and company celebrations. Group transportation can be arranged between offices, hotels, airports and event venues according to the program schedule."
},
{
name: "Bharat Benz Bus for School Trips Pune",
description: "Bharat Benz buses are suitable for school excursions involving students, teachers and accompanying staff. They can support educational tours, historical visits, nature trips, museums, recreational outings and longer school travel programs."
},
{
name: "Bharat Benz Bus for Family Trip Pune",
description: "Families traveling in larger numbers can hire a Bharat Benz bus from Pune for holidays, pilgrimages, reunions and weekend vacations. Traveling together provides convenient group coordination along with practical space for passengers and luggage."
},
{
name: "Bharat Benz Bus for Group Travel Pune",
description: "Bharat Benz buses provide a convenient transportation option for friends, relatives, community groups and organized tour parties. One dedicated vehicle helps everyone follow the same travel schedule and reduces the need for multiple smaller vehicles."
},
{
name: "Bharat Benz Bus for Picnic Pune",
description: "For office, school, college and family picnics, a Bharat Benz bus offers convenient shared transportation from Pune. Groups can carry bags, food and picnic equipment while traveling together to nearby or outstation destinations."
},
{
name: "Bharat Benz Bus for Airport Pickup Pune",
description: "Bharat Benz bus services for airport pickup are useful when a large group arrives together at Pune Airport with several suitcases and travel bags. A dedicated bus can simplify transfers between the airport, hotels, offices and other planned destinations."
},
{
name: "Bharat Benz Bus Near Me Pune",
description: "Customers searching for a Bharat Benz bus near them in Pune can choose a suitable group transportation solution according to passenger count and trip requirements. The service can support local travel, sightseeing, events, airport transfers and outstation journeys."
},
{
name: "Bharat Benz Bus Rental Service Pune",
description: "The Bharat Benz bus rental service in Pune is suitable for families, businesses, schools, tourists and event organizers requiring group transportation. Vehicle arrangements can be planned for local requirements as well as longer routes and multi-day travel."
},
{
name: "Bharat Benz Bus Hire for Events Pune",
description: "Bharat Benz bus hire for events in Pune can support transportation for exhibitions, conferences, cultural programs, private functions and large gatherings. Dedicated group buses make it easier to move attendees between venues, hotels, parking areas and other locations."
},
{
name: "Bharat Benz Bus for Marriage Pune",
description: "Marriage transportation becomes easier to coordinate when guests travel together in a dedicated Bharat Benz bus. It can be used for transfers between family residences, hotels, marriage halls, reception venues and other locations involved in the celebration."
},
{
name: "Bharat Benz Outstation Bus Rental Pune",
description: "Bharat Benz outstation bus rental from Pune is designed for longer group journeys covering tourist destinations, pilgrimage routes, beaches, hill stations and major cities. It is particularly useful for groups planning extended itineraries with multiple stops."
},
{
name: "Affordable Bharat Benz Bus Rental Pune",
description: "Affordable Bharat Benz bus rental in Pune provides a practical way for groups to access dedicated transportation without arranging multiple cars. Selecting the appropriate bus capacity helps maintain a balance between passenger comfort, space and overall travel requirements."
},
{
name: "Bharat Benz AC Tourist Bus Pune",
description: "Bharat Benz AC tourist buses in Pune are suitable for sightseeing tours and longer holiday journeys where passenger comfort is important. Air-conditioned interiors provide a convenient travel environment for families, tourists, corporate groups and organized tour parties."
},
{
name: "Bharat Benz Luxury Bus Hire Pune",
description: "Luxury Bharat Benz bus hire in Pune is an option for premium group transportation during corporate programs, weddings, special celebrations and destination tours. It allows larger groups to travel together while enjoying a more comfortable and refined travel environment."
}
],
tableData: [
["BharatBenz Bus Rental Pune", "Bharat Benz Bus Hire Pune"],
["Bharat Benz Bus Booking Pune", "Bharat Benz AC Bus on Rent Pune"],
["Bharat Benz Luxury Bus Rental Pune", "Bharat Benz Tourist Bus Pune"],
["Bharat Benz Bus for Outstation Pune", "Bharat Benz Bus for Wedding Pune"],
["Bharat Benz Bus for Corporate Events Pune", "Bharat Benz Bus for School Trips Pune"],
["Bharat Benz Bus for Family Trip Pune", "Bharat Benz Bus for Group Travel Pune"],
["Bharat Benz Bus for Picnic Pune", "Bharat Benz Bus for Airport Pickup Pune"],
["Bharat Benz Bus Near Me Pune", "Bharat Benz Bus Rental Service Pune"],
["Bharat Benz Bus Hire for Events Pune", "Bharat Benz Bus for Marriage Pune"],
["Bharat Benz Outstation Bus Rental Pune", "Affordable Bharat Benz Bus Rental Pune"],
["Bharat Benz AC Tourist Bus Pune", "Bharat Benz Luxury Bus Hire Pune"]
],
whychoose: [
{
WhyChooseheading: "Comfortable Group Travel",
WhyChoosedescription: "Bharat Benz buses provide a spacious group travel environment that is suitable for both local and long-distance journeys. Families, tourists and organizations can keep their passengers together while making transportation easier to coordinate."
},
{
WhyChooseheading: "Suitable for Long Routes",
WhyChoosedescription: "For extended journeys from Pune, a dedicated Bharat Benz bus can provide a practical alternative to using several smaller vehicles. It is suitable for multi-day tours, pilgrimage trips, destination weddings and holiday itineraries."
},
{
WhyChooseheading: "AC and Luxury Options",
WhyChoosedescription: "Groups looking for additional comfort can consider AC and luxury Bharat Benz options for their journey. These categories are particularly useful for corporate programs, premium tours, weddings and travel during warmer weather."
},
{
WhyChooseheading: "Ideal for Large Groups",
WhyChoosedescription: "A larger-capacity bus helps accommodate families, school groups, employees, tourists and wedding guests in a single transportation arrangement. This makes group movement more organized and reduces dependence on multiple cars."
},
{
WhyChooseheading: "Useful for Events and Functions",
WhyChoosedescription: "Bharat Benz buses can support transportation for weddings, marriages, corporate events, school programs, picnics and private functions. Dedicated transportation helps guests and participants move between important locations according to the event schedule."
},
{
WhyChooseheading: "Convenient for Tourist Tours",
WhyChoosedescription: "Tour groups can use Bharat Benz buses for sightseeing programs covering several attractions and destinations. Keeping the group in one vehicle makes itinerary coordination easier and provides a shared travel experience."
},
{
WhyChooseheading: "Practical Luggage Capacity",
WhyChoosedescription: "Group tours often involve suitcases, bags and other travel belongings, particularly during multi-day trips. A spacious bus provides a more practical transportation arrangement for passengers traveling with larger amounts of luggage."
},
{
WhyChooseheading: "Flexible Pune-Based Service",
WhyChoosedescription: "Ruturaj Enterprises supports Bharat Benz bus requirements for both Pune-based local travel and destinations outside the city. The service can be planned around the group size, route, occasion and duration of the journey."
}
]
};







const faqData = [
{
question: "Can I rent a Bharat Benz bus in Pune?",
answer: "A Bharat Benz bus can be rented in Pune for group travel, sightseeing, corporate programs, weddings, events, school trips, and outstation journeys. Ruturaj Enterprises can help arrange a suitable bus according to the passenger count, route, luggage requirements, trip duration, and preferred comfort level."
},
{
question: "What makes a Bharat Benz bus suitable for group travel?",
answer: "Bharat Benz buses are a suitable consideration for groups that want a spacious and organized travel arrangement. A dedicated bus allows passengers to stay together during the journey while making it easier to coordinate luggage, scheduled stops, sightseeing plans, and departure timings."
},
{
question: "Can I hire a Bharat Benz bus for an outstation trip from Pune?",
answer: "Outstation Bharat Benz bus rental can be arranged for group journeys from Pune to destinations such as Mumbai, Goa, Mahabaleshwar, Nashik, Shirdi, Kolhapur, Lonavala, and other cities. The rental plan can be matched with the route, passenger capacity, travel duration, and itinerary."
},
{
question: "Can a Bharat Benz bus be hired for local sightseeing in Pune?",
answer: "Groups can use a Bharat Benz bus for planned local sightseeing, educational excursions, corporate outings, family programs, and organized tours around Pune. The itinerary can be structured around selected locations, pickup points, sightseeing duration, and the group's preferred return schedule."
},
{
question: "Is Bharat Benz bus rental suitable for weddings in Pune?",
answer: "Wedding organizers and families can hire a Bharat Benz bus to transport guests between hotels, homes, wedding venues, reception locations, and other event destinations. A dedicated vehicle helps keep larger groups together and makes guest transportation easier to coordinate."
},
{
question: "Can corporate groups rent a Bharat Benz bus in Pune?",
answer: "Corporate teams can arrange Bharat Benz bus rental for employee outings, conferences, company events, training programs, team-building activities, and business travel. Group transportation provides a common vehicle for employees and helps maintain a coordinated schedule throughout the program."
},
{
question: "Can I book an AC Bharat Benz bus on rent in Pune?",
answer: "Travelers looking for additional comfort can inquire about an AC Bharat Benz bus based on availability and their specific requirements. Ruturaj Enterprises can help determine a suitable option after considering passenger numbers, route distance, luggage, journey duration, and travel preferences."
},
{
question: "What group sizes can travel in a Bharat Benz bus?",
answer: "The appropriate bus capacity depends on the size of the group and the luggage being carried. Bharat Benz options can be considered for different group transportation requirements, with vehicle selection based on passenger count, journey duration, comfort expectations, and the planned itinerary."
},
{
question: "Can students hire a Bharat Benz bus for an educational trip from Pune?",
answer: "School and college groups can arrange a Bharat Benz bus for educational tours, excursions, industrial visits, picnics, and outstation study trips. Traveling together makes student movement easier to coordinate while allowing teachers or organizers to manage the overall journey more efficiently."
},
{
question: "Why choose Ruturaj Enterprises for Bharat Benz bus rental in Pune?",
answer: "Ruturaj Enterprises provides group transportation options for local and outstation journeys, including sightseeing, weddings, corporate programs, educational trips, and tour packages. Bharat Benz bus selection can be planned around group size, route, luggage, travel duration, and the desired level of comfort."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Sameer Bhosale",
feedback:
"We rented a Bharat Benz bus from Ruturaj Enterprises for our group's outstation tour from Pune. The spacious bus was a good fit for our travel group, and having everyone together made the long journey much easier to coordinate. The overall transportation arrangement was very convenient.",
rating: 5
},
{
id: 2,
name: "Miss. Aarti Shinde",
feedback:
"Our family arranged a Bharat Benz bus for a wedding event in Pune, and Ruturaj Enterprises handled the group transportation requirement well. Guests could travel together between the different locations without arranging separate cars. The experience was comfortable and well organized.",
rating: 5
}
];













































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
        { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller on Rent", link: "Pune-to-Shirdi-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller", link: "Pune-to-Goa-Tempo-Traveller" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "Pune-to-Mumbai-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/6.jpg", text: "Pune to Konkan Tempo Traveller", link: "Pune-to-Konkan-Tempo-Traveller" },
        { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "Pune-to-Nashik-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller On Rent", link: "Pune-Darshan-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller on Rent", link: "13-Seater-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/12.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller on Rent in Pune", link: "26-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/14.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
        { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/16.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/18.jpg", text: "Bus Rentals For School Trips in Pune", link: "Bus-Rentals-For-School-Trips-in-Pune" },
        { place: "/images/keyword/19.jpg", text: "Bus booking for wedding in Pune", link: "Bus-booking-for-wedding-in-Pune" },
        { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage", link: "Bus-Booking-for-Marriage" },
        { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate Pune", link: "Bus-Service-for-Corporate-Pune" },
        { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "Bus-on-Rent-For-Event-in-Pune" },
        { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation", link: "Bus-Hire-for-Outstation" },
        { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "AC-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "Pune-Bus-Hire-Rental-Service" },
    ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bharat Benz bus on Rent Pune",
  "image": "https://ruturajenterprises.com/assets/images/bharat-benz-bus-on-rent-pune.webp",
  "description":
    "Bharat Benz bus on Rent Pune for comfortable local and outstation journeys, family tours, group travel, weddings, corporate events, school trips, picnics, sightseeing and special occasions. Ruturaj Enterprises offers BharatBenz and Bharat Benz bus rental options with comfortable seating, air conditioning, spacious interiors, experienced drivers and flexible rental plans for one-day trips as well as long-distance travel from Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Ruturaj Enterprises"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://ruturajenterprises.com/bharat-benz-bus-on-rent-pune"
  }
};





    return (
        <div>

<Helmet>
  <title>
    Bharat Benz bus on Rent Pune | BharatBenz Bus Rental Pune | +91 9763381382
  </title>

  <meta
    name="description"
    content="Bharat Benz bus on Rent Pune for local travel, outstation tours, family trips, group journeys, weddings, corporate events and sightseeing. Hire comfortable BharatBenz AC and luxury buses from Ruturaj Enterprises."
  />

  <meta
    name="keywords"
    content="BharatBenz Bus Rental Pune, Bharat Benz Bus Hire Pune, Bharat Benz Bus Booking Pune, Bharat Benz AC Bus on Rent Pune, Bharat Benz Luxury Bus Rental Pune, BharatBenz Bus on Rent Pune, Bharat Benz Bus on Rent Pune, BharatBenz Bus Hire Pune, BharatBenz Bus Booking Pune, BharatBenz AC Bus Rental Pune, BharatBenz AC Bus Hire Pune, BharatBenz Luxury Bus Hire Pune, Bharat Benz Luxury Bus Hire Pune, Bharat Benz Bus Rental Service Pune, Bharat Benz Bus Hire Service Pune, Bharat Benz Bus Booking Service Pune, Bharat Benz Bus for Outstation Pune, Bharat Benz Bus for Local Travel Pune, Bharat Benz Bus for Family Trip Pune, Bharat Benz Bus for Group Travel Pune, Bharat Benz Bus for Wedding Pune, Bharat Benz Bus for Corporate Events Pune, Bharat Benz Bus for School Trips Pune, Bharat Benz Bus for Picnic Pune, Bharat Benz Bus for Tourist Travel Pune, Bharat Benz Tourist Bus Pune, Bharat Benz Bus for Sightseeing Pune, Bharat Benz Bus for Pune Darshan, Bharat Benz Bus for Airport Pickup Pune, Bharat Benz Bus for Airport Drop Pune, Bharat Benz Outstation Bus Rental Pune, Bharat Benz Local Bus Rental Pune, Bharat Benz AC Bus Hire Pune, Bharat Benz Non AC Bus Rental Pune, Bharat Benz Luxury Bus on Rent Pune, Bharat Benz Mini Bus Rental Pune, Bharat Benz Tourist Bus Rental Pune, Bharat Benz Group Tour Bus Pune, Bharat Benz Family Tour Bus Pune, Bharat Benz Corporate Bus Pune, Bharat Benz Wedding Bus Rental Pune, Bharat Benz Marriage Bus Hire Pune, Bharat Benz School Tour Bus Pune, Bharat Benz One Day Tour Bus Pune, Bharat Benz Multi Day Tour Bus Pune, Bharat Benz Religious Tour Bus Pune, Bharat Benz Temple Tour Bus Pune, Bharat Benz Maharashtra Tour Pune, Bharat Benz Goa Trip Bus Pune, Bharat Benz Mumbai Trip Bus Pune, Bharat Benz Lonavala Trip Bus Pune, Bharat Benz Mahabaleshwar Trip Bus Pune, Bharat Benz Nashik Trip Bus Pune, Bharat Benz Shirdi Trip Bus Pune, Bharat Benz Kolhapur Trip Bus Pune, Bharat Benz Konkan Trip Bus Pune, Bharat Benz Bus Rental Near Me Pune, Bharat Benz Bus Hire Near Me Pune, Affordable Bharat Benz Bus Rental Pune, Comfortable Bharat Benz Bus Pune, Premium Bharat Benz Bus Rental Pune, Ruturaj Enterprises Bharat Benz Bus Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image"
                style={{ backgroundImage: "url('/img/bg/9.jpg')" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                                <div className="section-title-area ltn__section-title-2">
                                    <h1 className="section-title white-color">
                                        {cardData.keyword}
                                    </h1>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>






















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/47.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Ruturaj Enterprises: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">

                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable /> */}

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Ruturaj Enterprises</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ruturaj Enterprises </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                {/* <FleetHighway /> */}
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919763381382" className="pc-call">+91 9763381382</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919011051114" className="pc-call">+91 9011051114</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919822697554" className="pc-call">+91 9822697554</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919763381382"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919763381382" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@ruturajenterprises.com" className="pc-email">
                                            booking@ruturajenterprises.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Ruturaj Enterprises</strong><br />

                                            Nandini Takle Nagar, Pune - Solapur Road Manjri Bk Hadapsar, Pune, Maharashtra 412307
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Bharatbenzbusonrentpune ;